import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

const MapResizer = () => {
  const map = useMap();

  useEffect(() => {
    // We can use a ResizeObserver on the map container
    if (!map) return;
    const container = map.getContainer();
    
    const resizeObserver = new ResizeObserver(() => {
      // Use requestAnimationFrame to avoid "ResizeObserver loop limit exceeded"
      requestAnimationFrame(() => {
        map.invalidateSize();
      });
    });
    
    resizeObserver.observe(container);
    
    // Fallback window resize listener
    const handleResize = () => {
      map.invalidateSize();
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [map]);

  return null;
};

export default MapResizer;
